(function($){

	let newsletterForm = $('#bar-newsletter');

	if(!newsletterForm || newsletterForm.length < 1){
		return;
	}

	newsletterForm.validate({

        ignore: [],
        rules: {
			"bar-newsletter-email" : {
	            required: true,
	            email: true,
	        },
        },
        errorPlacement: function(error, element) {
            error.appendTo( $(element).closest("#bar-newsletter").find('.bar-newsletter__alert') );
        },
        highlight: function(element) {
            $(element).closest(".bar-form-field").addClass('bar-form-field--has-error');
        },
        unhighlight: function(element) {
            $(element).closest(".bar-form-field").removeClass('bar-form-field--has-error');
        },

        submitHandler: function(form){

            $.ajax({
		        type: "POST",
		        dataType: "json",
		        url: var_bar_ajax.url,
		        data: {
		        	action : var_bar_ajax.action,
					nonce: var_bar_ajax.nonce,
					callback: 'bar-register-newsletter',
					formData: $(form).serialize(),
		        },
		        success: function(response){
		        	console.log(response);
		        },
		        error : function(jqXHR, textStatus, errorThrown) {
		        	console.log('Error desconocido');
		        	console.log(errorThrown);
		        }

		    }); // $.ajax
        }
    });

})(jQuery)